import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { WrapperResponse } from './service-common';
import type { CustomerNotificationConfigDTO, CustomerNotificationTypeDTO } from '../core/models';

/**
 * Catálogo de correos al cliente final y configuración headless de la compañía. El guardado va con el de la página
 * (`POST /companies/{id}/config`).
 */
@Injectable({ providedIn: 'root' })
export class CustomerNotificationService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  getTypes(): Observable<WrapperResponse<CustomerNotificationTypeDTO[]>> {
    return this.http.get<WrapperResponse<CustomerNotificationTypeDTO[]>>(`${this.apiUrl}/customer-notification-types`);
  }

  getConfig(companyId: number): Observable<WrapperResponse<CustomerNotificationConfigDTO>> {
    return this.http.get<WrapperResponse<CustomerNotificationConfigDTO>>(
      `${this.apiUrl}/companies/${companyId}/customer-notification-config`
    );
  }
}
